import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Youtube } from 'lucide-react'
import ClickablePhone from './ClickablePhone'
import { COMPANY_STATS } from '../constants/stats'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    services: [
      { name: 'Обработка днища', href: '/services#bottom' },
      { name: 'Обработка полостей', href: '/services#cavities' },
      { name: 'Пескоструйная очистка', href: '/services#sandblasting' },
      { name: 'Комплексная обработка', href: '/services#complex' },
      { name: 'Защита кузова', href: '/services#body' }
    ],
    company: [
      { name: 'О нас', href: '/about' },
    ],
    support: [
      { name: 'Контакты', href: '/contact' },
      { name: 'FAQ', href: '/faq' },
      { name: 'Гарантия', href: '/warranty' },
      { name: 'Поддержка', href: '/support' }
    ]
  }

  return (
    <footer className="bg-secondary-900 text-white">
      {/* Main Footer Content */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-accent-500 rounded-lg flex items-center justify-center text-white font-bold text-xl">
                А
              </div>
              <div>
                <div className="font-heading font-bold text-xl">
                  Антикор
                </div>
                <div className="text-sm text-secondary-400">
                  Брест
                </div>
              </div>
            </div>
            <p className="text-secondary-300 mb-6 leading-relaxed">
              Профессиональная антикоррозийная обработка автомобилей в Бресте.
              Защищаем ваш автомобиль от коррозии с 2019 года.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">Услуги</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-secondary-300 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">Контакты</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-primary-400 mt-1 flex-shrink-0" />
                <div>
                  <div className="text-white font-medium">
                    <ClickablePhone
                      phone={COMPANY_STATS.phone}
                    />
                  </div>
                  <div className="text-secondary-400 text-sm">Звоните в любое время</div>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary-400 mt-1 flex-shrink-0" />
                <div>
                  <div className="text-white font-medium">г. Брест, ул. Мощенского, 90</div>
                  <div className="text-secondary-400 text-sm">Удобное расположение</div>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <Clock className="w-5 h-5 text-primary-400 mt-1 flex-shrink-0" />
                <div>
                  <div className="text-white font-medium">Пн-Пт: 9:00-18:00</div>
                  <div className="text-secondary-400 text-sm">Сб: 9:00-15:00</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-secondary-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-secondary-400 text-sm">
              © {currentYear} Антикор Авто Брест. УНП 291857843. Все права защищены.
            </div>

            <div className="flex items-center space-x-6 text-sm text-secondary-400">
              <Link to="/sitemap" className="hover:text-white transition-colors duration-200">
                Карта сайта
              </Link>
            </div>
          </div>
        </div>
        <div className="container-custom py-6">
          <div className="text-secondary-400 text-sm">
            Цены указанные на сайте anticor-auto.by приведены как справочная информация и не являются публичной офертой.
            Могут быть изменены в любое время и без предупреждения.
          </div>
        </div>
      </div>



      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 w-12 h-12 bg-primary-600 hover:bg-primary-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-110 z-40"
        aria-label="Вернуться наверх"
      >
        <svg className="w-6 h-6 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </button>
    </footer>
  )
}

export default Footer
